(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cdv-brands-innovation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded',()=>{
    var brandSlider = new Swiper('.brands_slider_main_wrapper .swiper-container', {spaceBetween: 0,centeredSlides: true,speed: 6000,autoplay: {delay: 1},loop: true,slidesPerView:'auto',allowTouchMove: false,disableOnInteraction: true});
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdv-brands-logo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded',()=>{
    var brandLogoSlider = new Swiper('.brand__logo__container_interior.swiper', {spaceBetween: 0,centeredSlides: true,speed: 6000,autoplay: {delay: 1},loop: true,slidesPerView:'auto',allowTouchMove: false,disableOnInteraction: true});
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdv-build-layout"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {

    /* ---------- COUNTER STATE ---------- */
    let counterStarted = false;

    function animateCounter(span) {
      let end = parseInt(span.getAttribute('data-target'), 10);
      if (isNaN(end)) {
        end = parseInt((span.textContent || '').replace(/[^\d]/g, ''), 10) || 0;
        span.setAttribute('data-target', end);
      }

      const duration = 1500;
      const startTime = performance.now();
      span.textContent = '0';

      function step(now) {
        const progress = Math.min((now - startTime) / duration, 1);
        span.textContent = Math.floor(end * progress);
        if (progress < 1) requestAnimationFrame(step);
        else span.textContent = end;
      }
      requestAnimationFrame(step);
    }

    function runAllCounters() {
      if (counterStarted) return;
      counterStarted = true;
      document.querySelectorAll('.build__ratings span').forEach(animateCounter);
    }

    /* ---------- EXISTING SWIPER COLUMNS (unchanged) ---------- */
    function buildColumn(selector, speed) {
      if (!document.querySelector(selector)) return null;

      return new Swiper(selector, {
        direction: 'vertical',
        loop: true,
        loopedSlides: 6,
        slidesPerView: 'auto',
        spaceBetween: 30,
        speed: speed,
        allowTouchMove: false,
        simulateTouch: false,
        preventClicks: false,
        preventClicksPropagation: false,
        roundLengths: true,
        freeMode: { enabled: true, momentum: false },
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
          reverseDirection: false
        },
        watchSlidesProgress: true,
        observer: true,
        observeParents: true
      });
    }

    buildColumn('.build__layout_column-left.swiper-container', 6000);
    buildColumn('.build__layout_column-right.swiper-container', 6000);
    buildColumn('.build__layout_column-center.swiper-container-style', 5000);

    /* ---------- RANKS MOBILE AUTO SLIDER (smooth marquee) ---------- */
    const SLIDES_PER_VIEW = 2;
    const GAP = 16;
    const SPEED = 40;
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const container = document.querySelector('.build__layout_ranks_layout');
    const wrapper = document.querySelector('.build__layout_ranks');

    let rafId = null;
    let clones = [];
    let originals = [];
    let isActive = false;
    let offset = 0;
    let loopWidth = 0;
    let lastTime = 0;

    function setup() {
      teardown();
      if (!container || !wrapper) return;

      originals = Array.prototype.slice.call(
        wrapper.querySelectorAll(':scope > .build__layout_ranking')
      );
      if (originals.length < 2) return;

      isActive = true;

      container.style.overflow = 'hidden';

      wrapper.style.display = 'flex';
      wrapper.style.flexWrap = 'nowrap';
      wrapper.style.gap = GAP + 'px';
      wrapper.style.width = 'max-content';
      wrapper.style.willChange = 'transform';
      wrapper.style.transform = 'translate3d(0,0,0)';

      const slideWidth =
        (container.clientWidth - GAP * (SLIDES_PER_VIEW - 1)) / SLIDES_PER_VIEW;

      originals.forEach(function (slide) {
        slide.style.flex = '0 0 ' + slideWidth + 'px';
        slide.style.width = slideWidth + 'px';
        slide.style.minWidth = slideWidth + 'px';
      });

      const setWidth = (slideWidth + GAP) * originals.length;
      let totalWidth = setWidth;

      while (totalWidth < container.clientWidth + setWidth) {
        originals.forEach(function (slide) {
          const clone = slide.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.classList.add('ranks-js-clone');
          wrapper.appendChild(clone);
          clones.push(clone);

          if (counterStarted) {
            clone.querySelectorAll('.build__ratings span').forEach(function (s) {
              const t = parseInt(s.getAttribute('data-target'), 10);
              if (!isNaN(t)) s.textContent = t;
            });
          }
        });
        totalWidth += setWidth;
      }

      loopWidth = setWidth;
      offset = 0;
      lastTime = 0;
      rafId = requestAnimationFrame(tick);
    }

    function tick(now) {
      if (!isActive) return;

      if (!lastTime) lastTime = now;
      let delta = (now - lastTime) / 1000;
      lastTime = now;

      if (delta > 0.1) delta = 0.016;

      offset += SPEED * delta;
      if (offset >= loopWidth) offset -= loopWidth;

      wrapper.style.transform = 'translate3d(' + (-offset) + 'px,0,0)';
      rafId = requestAnimationFrame(tick);
    }

    function teardown() {
      isActive = false;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;

      clones.forEach(function (c) { c.remove(); });
      clones = [];

      if (container) container.style.overflow = '';

      if (wrapper) {
        wrapper.style.display = '';
        wrapper.style.flexWrap = '';
        wrapper.style.gap = '';
        wrapper.style.width = '';
        wrapper.style.willChange = '';
        wrapper.style.transform = '';
      }

      originals.forEach(function (slide) {
        slide.style.flex = '';
        slide.style.width = '';
        slide.style.minWidth = '';
      });
      originals = [];
    }

    function handleBreakpoint() {
      if (mobileQuery.matches) setup();
      else teardown();
    }

    handleBreakpoint();

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', handleBreakpoint);
    } else {
      mobileQuery.addListener(handleBreakpoint);
    }

    let resizeTimer;
    let lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleBreakpoint, 200);
    });

    /* ---------- COUNTER TRIGGER ---------- */
    const observeTarget =
      document.querySelector('.build__layout_wrapper') || container || wrapper;

    if (!observeTarget) return;

    if (!('IntersectionObserver' in window)) {
      runAllCounters();
      return;
    }

    const counterObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          runAllCounters();
          obs.disconnect();
        }
      });
    }, { threshold: 0.1 });

    counterObserver.observe(observeTarget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdv-build-vertical-layout"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    function buildColumn(selector, speed) {
      if (!document.querySelector(selector)) return null;
      return new Swiper(selector, {
        direction: 'vertical',
        loop: true,
        loopedSlides: 6,
        slidesPerView: 'auto',
        spaceBetween: 30,
        speed: speed,
        allowTouchMove: false,
        roundLengths: true,
        freeMode: { enabled: true, momentum: false },
        freeModeMomentum: false,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: false,
        },
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
      });
    }

    var buildVerticalSwiperLeft = buildColumn('.build__layout_column_vertical-left.swiper-container', 6000);
    var buildVerticalSwiperRight = buildColumn('.build__layout_column_vertical-right.swiper-container', 6000);
    var buildVerticalSwiperCenter = buildColumn('.build__layout_column_vertical-center.swiper-container-style', 5000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdv-development-firm"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.development__firm_wrapper').forEach(function (section) {
    var container = section.querySelector('.development_firm_logo_container');
    var track = section.querySelector('.block__development-firm-list');

    if (!container || !track || track.children.length < 2) return;

    var items = Array.from(track.children);
    var frame, x = 0, width = 0;

    function slider() {
      if (window.innerWidth > 767) {
        cancelAnimationFrame(frame);
        track.style.transform = '';
        container.style.overflow = '';
        return;
      }

      container.style.overflow = 'hidden';
      track.style.display = 'flex';
      track.style.width = 'max-content';

      if (!track.dataset.cloned) {
        items.forEach(function (item) {
          track.appendChild(item.cloneNode(true));
        });
        track.dataset.cloned = 'true';
        width = track.scrollWidth / 2;
      }

      cancelAnimationFrame(frame);

      function move() {
        x = (x + 0.5) % width;
        track.style.transform = 'translateX(-' + x + 'px)';
        frame = requestAnimationFrame(move);
      }

      move();
    }

    slider();
    window.addEventListener('resize', slider);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdv-image-animation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const animationImagesLayout = document.querySelectorAll('.section__animation_container');
  function updateActiveSection() {
    let viewportMiddle;
    if (window.screen.width > 749 ){
      viewportMiddle = window.innerHeight / 2;
    }else{
      viewportMiddle = window.innerHeight;
    }
    let targetSection = null;
    animationImagesLayout.forEach(section => {
      const rect = section.getBoundingClientRect();
      if (rect.top <= viewportMiddle && rect.bottom > viewportMiddle) {
        targetSection = section;
      }
    });
    animationImagesLayout.forEach(section => {
      if (section === targetSection) {
        const bg_color = section.dataset.bg;
        const normal_color = section.dataset.color;
        const button_bg = section.dataset.buttonBg;
        const button_color = section.dataset.buttonColor;
        document.querySelector('.image_animation_container').style.backgroundColor = bg_color;
        section.querySelector('.image_row__heading').style.color = normal_color;
        section.querySelector('.image__row__paragraph').style.color = normal_color;
        section.querySelector('.image__row__buttons a').style.backgroundColor = button_bg;
        section.querySelector('.image__row__buttons a').style.color = button_color;
        section.querySelector('.image__row__buttons a svg path').setAttribute('style',`fill:${button_color}`);
        section.querySelector('.image__row__buttons a svg path').setAttribute('fill',`${button_color}`);
        section.classList.add('active');
      } else {
        section.classList.remove('active');
      }
    });
  }
  window.addEventListener('scroll', updateActiveSection);
  updateActiveSection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdv-our-process"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    if ( window.screen.width > 749 ){
      let isDown = false,startX,scrollLeft;
      const slider = document.querySelector('.our-process__listing');
      const end = () => { isDown = false;slider.classList.remove('active'); }
      const start = (e) => { isDown = true; slider.classList.add('active'); startX = e.pageX || e.touches[0].pageX - slider.offsetLeft; scrollLeft = slider.scrollLeft; }
      const move = (e) => {
        if(!isDown) return;
        e.preventDefault();
        const x = e.pageX || e.touches[0].pageX - slider.offsetLeft;
        const dist = (x - startX);
        slider.scrollLeft = scrollLeft - dist;
      }
      (() => {
      	slider.addEventListener('mousedown', start);
      	slider.addEventListener('touchstart', start);
      	slider.addEventListener('mousemove', move);
      	slider.addEventListener('touchmove', move);
      	slider.addEventListener('mouseleave', end);
      	slider.addEventListener('mouseup', end);
      	slider.addEventListener('touchend', end);
      })();    
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdv-partners"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    function brandLogoAnimation(elem) { 
      var bounding = elem.getBoundingClientRect();
      var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
      var elementVisibleHeight = Math.min(bounding.bottom, windowHeight) - Math.max(bounding.top, 0);
      if (elementVisibleHeight >= elem.offsetHeight / 2) {
          return true;
      }
      return false;
    };
    let LogoElementvisible = document.querySelectorAll('.partner__own_company');
    window.addEventListener('scroll', ()=>{
      LogoElementvisible.forEach( (evt)=>{
        if ( brandLogoAnimation(evt) ) {
          evt.closest('.partner__logos_initiated').classList.add('animated');
        }else{
          evt.closest('.partner__logos_initiated').classList.remove('animated');
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdv-top-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    var topbarSlide = new Swiper ('.announcment-bar__main_swiper.swiper',{slidesPerView:1,loop: true,autoplay:{delay:2500,disableOnInteraction: false}});
  })  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdv-video-poster-row"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelector('.block__task-video-box-play').addEventListener('click',(elm)=>{
      elm.preventDefault();
      let videoFound = elm.target.closest('.video__exist_row').querySelector('img').getAttribute('video_capture');
      elm.target.closest('.video__exist_row').innerHTML = videoFound;
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    function isInViewportStickyMobileButtons(elem) {
      var bounding = elem.getBoundingClientRect();
      var myElementHeight = elem.offsetHeight;
      var myElementWidth = elem.offsetWidth;
      return (
        bounding.top >= -myElementHeight &&
        bounding.left >= -myElementWidth &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight
      );
    }
    let MobileElementvisible = document.querySelectorAll('.main__banner_buttons');
    window.addEventListener('scroll', () => {
      MobileElementvisible.forEach((evt) => {
        if (
          !isInViewportStickyMobileButtons(evt) &&
          window.screen.width < 749 &&
          !isInViewportStickyMobileButtons(document.querySelector('.footer_layout_wrapper'))
        ) {
          document.querySelector('.stickyMobBtnBar').classList.remove('hidden');
        } else {
          document.querySelector('.stickyMobBtnBar').classList.add('hidden');
        }
      });
    });
    document.querySelectorAll('[js-collapsible-tab]').forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();

        const wrap = tab.closest('[js-collapsible-open]');
        const content = wrap.querySelector('[js-collapsible-content]') || tab.nextElementSibling;
        if (!content) return wrap.classList.toggle('active');

        const zero = {
          height: '0px',
          paddingTop: '0px',
          paddingBottom: '0px',
          marginTop: '0px',
          marginBottom: '0px',
          opacity: 0,
        };
        const read = () => {
          const cs = getComputedStyle(content);
          return {
            height: content.getBoundingClientRect().height + 'px',
            paddingTop: cs.paddingTop,
            paddingBottom: cs.paddingBottom,
            marginTop: cs.marginTop,
            marginBottom: cs.marginBottom,
            opacity: cs.opacity,
          };
        };

        const wasOpen = wrap.classList.contains('active');
        const opening = !wasOpen;

        const start = content.anim || wasOpen ? read() : zero;
        content.anim?.cancel();

        wrap.classList.toggle('active', opening);
        Object.assign(content.style, {
          display: 'block',
          overflow: 'hidden',
          boxSizing: 'border-box',
          transition: 'none',
          maxHeight: 'none',
          height: 'auto',
          willChange: 'height, opacity',
        });

        const end = opening ? read() : zero;

        const anim = (content.anim = content.animate([start, end], {
          duration: 350,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
          fill: 'forwards',
        }));

        anim.onfinish = () => {
          ['display', 'overflow', 'boxSizing', 'transition', 'maxHeight', 'height', 'willChange'].forEach(
            (p) => (content.style[p] = '')
          );
          anim.cancel();
          content.anim = null;
        };
      });
    });
  });

  // Animation text js
  document.addEventListener('DOMContentLoaded', () => {
    const message = document.querySelector('.message');
    const words = Array.from(document.querySelectorAll('.word1, .word2, .word3, .word4'));
    let currentIndex = -1;

    function showNextWord() {
      words.forEach((word) => word.classList.remove('word-visible'));

      currentIndex = (currentIndex + 1) % words.length;
      const currentWord = words[currentIndex];
      currentWord.classList.add('word-visible');

      const tempSpan = document.createElement('span');
      tempSpan.style.position = 'absolute';
      tempSpan.style.visibility = 'hidden';
      tempSpan.style.whiteSpace = 'nowrap';
      tempSpan.style.fontSize = getComputedStyle(currentWord).fontSize;
      tempSpan.style.fontFamily = getComputedStyle(currentWord).fontFamily;
      tempSpan.style.fontWeight = getComputedStyle(currentWord).fontWeight;
      tempSpan.textContent = currentWord.textContent;

      document.body.appendChild(tempSpan);
      const wordWidth = tempSpan.offsetWidth + 25;
      document.body.removeChild(tempSpan);

      message.style.width = '0px';
      setTimeout(() => {
        message.style.width = `${wordWidth}px`;
      }, 100);

      setTimeout(() => {
        message.style.width = '0px';
      }, 1800);
    }

    showNextWord();

    setInterval(showNextWord, 2500);

    words.forEach((word) => {
      word.addEventListener('click', () => {
        word.style.transform = 'scale(1.1)';
        setTimeout(() => {
          word.style.transform = 'scale(1)';
        }, 200);
      });
    });

    message.addEventListener('dblclick', () => {
      createSparkle(message);
    });

    function createSparkle(element) {
      const sparkle = document.createElement('span');
      sparkle.textContent = '✨';
      sparkle.style.position = 'absolute';
      sparkle.style.left = Math.random() * 100 + '%';
      sparkle.style.top = Math.random() * 100 + '%';
      sparkle.style.animation = 'sparkle 1s forwards';
      element.appendChild(sparkle);
      setTimeout(() => sparkle.remove(), 1000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('[js-mega-menu-layout]').forEach((elm)=>{
      elm.addEventListener('mouseenter', (target)=>{
        target.preventDefault();
        if( target.target.querySelectorAll('.mega__menu_layout_wrapper').length == 1 ){
            document.querySelectorAll('.has__maga_menu_layout').forEach((elm)=>{elm.classList.remove('active')});
            document.body.classList.remove('mega-menu-opened');             
            target.target.classList.add('active');
            document.body.classList.add('mega-menu-opened');
            document.body.style.maxWidth = `${window.screen.width - parseInt(15)}px`;
        }
      })
      elm.addEventListener('mouseleave', (target)=>{
        target.preventDefault();
        if( target.target.querySelectorAll('.mega__menu_layout_wrapper').length == 1 ){
            document.querySelectorAll('.has__maga_menu_layout').forEach((elm)=>{elm.classList.remove('active')});
            document.body.classList.remove('mega-menu-opened');             
            document.body.style.maxWidth = `auto`; 
        }
      })      
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["migration-brands-innovation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded',()=>{
    var brandSlider = new Swiper('.brands_slider_main_wrapper .swiper-container', {spaceBetween: 0,centeredSlides: true,speed: 6000,autoplay: {delay: 1},loop: true,slidesPerView:'auto',allowTouchMove: false,disableOnInteraction: true});
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["migration-company-intro"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

  function collapseSection(element) {
    var sectionHeight = element.scrollHeight;
    var elementTransition = element.style.transition;

    element.style.transition = '';

    requestAnimationFrame(function () {
      element.style.height = sectionHeight + 'px';
      element.style.transition = elementTransition;

      requestAnimationFrame(function () {
        element.style.height = '0px';
      });
    });

    element.closest('.migration_collapsible_list').classList.remove('active');
  }

  function expandSection(element) {
    var sectionHeight = element.scrollHeight;

    element.style.height = sectionHeight + 'px';
    element.addEventListener('transitionend', function handler(event) {
      if (event.propertyName !== 'height') return;

      element.removeEventListener('transitionend', handler);
      element.style.height = 'auto';
    });

    element.closest('.migration_collapsible_list').classList.add('active');
  }

document.querySelectorAll('.migration__company_introduction').forEach((section) => {
  const imageContainer = section.querySelector('.migration__image_container');

  if (imageContainer) {
    imageContainer.style.alignSelf = 'start';
  }
});

  document.querySelectorAll('.collapsible_button_group').forEach((elm) => {

    elm.addEventListener('click', function (event) {
      event.preventDefault();
      var currentItem = event.target.closest('.migration_collapsible_list');
      if (!currentItem) return;
      var currentContent = currentItem.querySelector('.collapsible_content_group');

      if (currentItem.classList.contains('active')) {
        collapseSection(currentContent);
        return;
      }

      var activeItem = document.querySelector('.migration_collapsible_list.active');

      if (activeItem) {
        var activeContent = activeItem.querySelector('.collapsible_content_group');

        if (activeContent) {
          collapseSection(activeContent);
        }
      }

      expandSection(currentContent);
    });

  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testing-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelector('.testbnrPlayIcon').addEventListener('click', (target)=>{
      target.preventDefault();
      let popupHTML = `<video playsinline="playsinline" controls="controls" preload="metadata" muted="true" autoplay="true"><source src="https://cdn.shopify.com/videos/c/o/v/3baef6ca48974bf9b3ebebbe3eedf52a.mp4" type="video/mp4"></video>`;
      document.querySelector('[js-video-popup]').insertAdjacentHTML('beforeend', popupHTML);
      document.querySelector('.video__popup_testing_banner').classList.add('active');
      document.body.classList.add('popup_overlay');
    });

    document.querySelector('.close_popup').addEventListener('click', (target)=>{
      target.preventDefault();
      document.querySelector('.video__popup_testing_banner').classList.remove('active');
      document.body.classList.remove('popup_overlay');        
      setTimeout(()=>{document.querySelector('[js-video-popup]').innerHTML = ''},500);
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testing-extensibility-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    function collapseSection(element) {
      var sectionHeight = element.scrollHeight;
      var elementTransition = element.style.transition;
      element.style.transition = '';
      requestAnimationFrame(function() {
        element.style.height = sectionHeight + 'px';
        element.style.transition = elementTransition;
        requestAnimationFrame(function() {
          element.style.height = 0 + 'px';
        });
      });
      document.querySelector('.abTestTabsBoxItem.active').classList.remove('active');
    }
    function expandSection(element) {
      var sectionHeight = element.scrollHeight;
      element.style.height = sectionHeight + 'px';
      element.addEventListener('transitionend', function(e) {
        element.removeEventListener('transitionend', arguments.callee);
        element.style.height = null;
      });
      element.closest('.abTestTabsBoxItem').classList.add('active');
    }
    document.querySelectorAll('.abTesttabsTitle').forEach((elm)=>{
      elm.addEventListener('click', function(target) {
        target.preventDefault();
        if(!target.target.closest('.abTestTabsBoxItem').classList.contains('active')) {
          var collapsedLayout = document.querySelector('.abTestTabsBoxItem.active').querySelector('.abTestTabsPanel');
          collapseSection(collapsedLayout)
          var expandLayout = target.target.closest('.abTestTabsBoxItem').querySelector('.abTestTabsPanel');
          expandSection(expandLayout)
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();
})();
